import { createAction } from '@reduxjs/toolkit';
/**
 * @description This action should be dispatched when a ViewUpdate realtime message
 * is received and validated by the validation endpoint.
 */
export const viewMemberUpserted = createAction('realtime/ViewUpsert', ({
  currentAgentId,
  message,
  sortState
}) => {
  return {
    payload: {
      currentAgentId,
      message,
      sortState
    }
  };
});